import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div>
  <label for="choose-topic-title">
    <span>{{i18n (or @label "choose_topic.title.search")}}</span>
  </label>

  <input
    {{on "keydown" this.ignoreEnter}}
    {{on "input" this.onTopicTitleChange}}
    type="text"
    placeholder={{i18n "choose_topic.title.placeholder"}}
    id="choose-topic-title"
  />

  {{#if this.loading}}
    <p>{{i18n "loading"}}</p>
  {{else if (not this.topics.length)}}
    <p>{{i18n "choose_topic.none_found"}}</p>
  {{else}}
    <div class="choose-topic-list" role="radiogroup">
      {{#each this.topics as |t|}}
        <div class="controls existing-topic">
          <label class="radio">
            <Input
              {{on "click" (fn this.chooseTopic t)}}
              @checked={{eq t.id this.selectedTopicId}}
              @type="radio"
              name="choose_topic_id"
              id={{concat "choose-topic-" t.id}}
            />
            <TopicStatus @topic={{t}} @disableActions={{true}} />
            <span class="topic-title">
              {{replace-emoji t.title}}
            </span>
            <span class="topic-categories">
              {{bound-category-link
                t.category
                ancestors=t.category.predecessors
                hideParent=true
                link=false
              }}
            </span>
          </label>
        </div>
      {{/each}}
    </div>
  {{/if}}
</div>
*/
{
  "id": "ze8ZKiSx",
  "block": "[[[10,0],[12],[1,\"\\n  \"],[10,\"label\"],[14,\"for\",\"choose-topic-title\"],[12],[1,\"\\n    \"],[10,1],[12],[1,[28,[35,0],[[28,[37,1],[[30,1],\"choose_topic.title.search\"],null]],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[11,\"input\"],[16,\"placeholder\",[28,[37,0],[\"choose_topic.title.placeholder\"],null]],[24,1,\"choose-topic-title\"],[24,4,\"text\"],[4,[38,2],[\"keydown\",[30,0,[\"ignoreEnter\"]]],null],[4,[38,2],[\"input\",[30,0,[\"onTopicTitleChange\"]]],null],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"loading\"]],[[[1,\"    \"],[10,2],[12],[1,[28,[35,0],[\"loading\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,0,[\"topics\",\"length\"]]],null],[[[1,\"    \"],[10,2],[12],[1,[28,[35,0],[\"choose_topic.none_found\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"choose-topic-list\"],[14,\"role\",\"radiogroup\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"topics\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"controls existing-topic\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"radio\"],[12],[1,\"\\n            \"],[8,[39,7],[[24,3,\"choose_topic_id\"],[16,1,[28,[37,8],[\"choose-topic-\",[30,2,[\"id\"]]],null]],[4,[38,2],[\"click\",[28,[37,10],[[30,0,[\"chooseTopic\"]],[30,2]],null]],null]],[[\"@checked\",\"@type\"],[[28,[37,9],[[30,2,[\"id\"]],[30,0,[\"selectedTopicId\"]]],null],\"radio\"]],null],[1,\"\\n            \"],[8,[39,11],null,[[\"@topic\",\"@disableActions\"],[[30,2],true]],null],[1,\"\\n            \"],[10,1],[14,0,\"topic-title\"],[12],[1,\"\\n              \"],[1,[28,[35,12],[[30,2,[\"title\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"topic-categories\"],[12],[1,\"\\n              \"],[1,[28,[35,13],[[30,2,[\"category\"]]],[[\"ancestors\",\"hideParent\",\"link\"],[[30,2,[\"category\",\"predecessors\"]],true,false]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[2]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[]]]],[]]],[13]],[\"@label\",\"t\"],false,[\"i18n\",\"or\",\"on\",\"if\",\"not\",\"each\",\"-track-array\",\"input\",\"concat\",\"eq\",\"fn\",\"topic-status\",\"replace-emoji\",\"bound-category-link\"]]",
  "moduleName": "discourse/components/choose-topic.hbs",
  "isStrictMode": false
});